<template>
  <div id="content-header" class="flex w-full justify-between px-4">
    <div class="left-item flex flex-wrap items-center">
      <feather-icon
        class="ml-4 mr-4"
        icon="MenuIcon"
        v-show="showMenuIcon"
        @click.stop="toggleDocumentSidebar(true)"
      ></feather-icon>
      <div id="search-area" class="flex">
        <feather-icon class="icon" icon="SearchIcon" svgClasses="h-5 w-4" />
        <vs-input
          :color="AISEA_COLOR.GRAY"
          placeholder="ファイル名を検索"
          v-model="searchQuery"
          class="flex py-2 vs-input-no-border vs-input-no-shdow-focus w-full"
        ></vs-input>
      </div>
    </div>
    <div class="right-item flex items-center">
      <div v-show="showMultipleSelectMenu" class="flex">
        <vx-tooltip :text="downloadIconText">
          <feather-icon
            v-show="!showMenuIcon && !disableMultipleDownloadIcon"
            class="icon p-2 mr-2 cursor-pointer"
            icon="DownloadIcon"
            svgClasses="h-5 w-5"
            @click="toggleMultipleDownload"
          />
          <feather-icon
            v-show="!showMenuIcon && disableMultipleDownloadIcon"
            class="icon-disabled p-2 mr-2"
            icon="DownloadIcon"
            svgClasses="h-5 w-5"
          />
        </vx-tooltip>

        <vx-tooltip text="削除">
          <feather-icon
            v-show="!showMenuIcon"
            class="icon p-2 mr-2 cursor-pointer"
            icon="TrashIcon"
            svgClasses="h-5 w-5"
            @click="toggleMultipleTrash"
          />
        </vx-tooltip>

        <div id="document-content-dropdown" class="inline-flex">
          <vs-dropdown
            vs-trigger-click
            :color="AISEA_COLOR.BLUE"
            class="icon p-2 cursor-pointer"
          >
            <a class="a-icon flex flex-warp" href="#">
              <feather-icon
                class="action-button-icon"
                svgClasses="h-5 w-5"
                icon="MoreVerticalIcon"
                @click.stop=""
              ></feather-icon>
            </a>
            <vs-dropdown-menu class="content-dropdown-menu">
              <vs-dropdown-item
                v-show="showMenuIcon"
                @click="toggleMultipleDownload"
                :disabled="disableMultipleDownloadIcon"
              >
                <span class="flex items-center">
                  <feather-icon
                    icon="DownloadIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{ downloadIconText }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-show="showMenuIcon"
                @click="toggleMultipleTrash"
              >
                <span class="flex items-center">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>削除</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="toggleMultipleImportant"
                :disabled="disableMultipleImportantIcon"
              >
                <span class="flex items-center">
                  <feather-icon
                    icon="StarIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{ importantText }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="toggleMultipleMoveFolder()">
                <span class="flex items-center">
                  <feather-icon
                    icon="FolderIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>移動</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="toggleMultipleCopyFolder()">
                <span class="flex items-center">
                  <feather-icon
                    icon="CopyIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>コピー</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <document-move-dialog
            ref="DocumentMoveDialog"
            :moveTargetDocments="moveDocuments"
          >
          </document-move-dialog>
          <document-copy-dialog
            ref="DocumentCopyDialog"
            :copyTargetDocments="moveDocuments"
          >
          </document-copy-dialog>
          <document-delete-dialog
            ref="DocumentDeleteDialog"
          ></document-delete-dialog>
        </div>
      </div>

      <switch-button
        :items="switchItems"
        :defaultSelected="selectedStyle"
        class="ml-2"
      />
    </div>
  </div>
</template>

<script>
import { DOCUMENT_KIND, DOCUMENT_SIDEBAR_KIND, DOCUMENT_DISPLAY_TYPE } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import SwitchButton from "@/components/buttons/SwitchButton"
import DocumentMoveDialog from "../dialog/DocumentMoveDialog"
import DocumentCopyDialog from "../dialog/DocumentCopyDialog"
import DocumentDeleteDialog from "../dialog/DocumentDeleteDialog"
import _ from "lodash"



const {
  mapActions: mapActionsOfEnterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  name: "DocumentContentHeader",
  mixins: [ColorMixin, DocumentMixin],
  components: { SwitchButton, DocumentMoveDialog, DocumentDeleteDialog, DocumentCopyDialog },
  data() {
    return {
      switchItems: [
        {
          key: DOCUMENT_DISPLAY_TYPE.GRID,
          icon: "GridIcon",
          selectedMethod: this.selectGridIcon
        },
        {
          key: DOCUMENT_DISPLAY_TYPE.LIST,
          icon: "ListIcon",
          selectedMethod: this.selectListIcon
        },
      ],
      selectedStatus: "s",
      disabledDownloadMsg: "フォルダが選択されている場合はダウンロードできません",
      moveDocuments: []
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "isDocumentSidebarActive",
      "isDocumentSidebarClickNotClose",
      "selectedContentViewStyle",
      "documentSearchQuery",
      "selectedDocuments",
      "searchDocumentsRange",
      "documentRootPath",
      "selectedSidebarItem"
    ]),
    isSidebarActive: {
      get() { return this.isDocumentSidebarActive },
      set(val) { this.SET_DOCUMENT_SIDEBAR_ACTIVE(val) }
    },
    selectedStyle: {
      get() {
        return this.selectedContentViewStyle
      },
      set(val) {
        this.SET_SELECTED_CONTENT_VIEW_STYLE(val)
      }
    },
    searchQuery: {
      get() {
        return this.documentSearchQuery
      },
      set(val) {
        this.SET_DOCUMENT_SEARCH_QUERY(val)
      }
    },
    important() {
      return this.selectedDocuments.filter(item => item.size).findIndex(item => item.important) !== -1
    },
    importantText() {
      return this.important ? "重要書類から削除" : "重要書類へ追加"
    },
    showMenuIcon() {
      return !this.isDocumentSidebarActive
    },
    showMultipleSelectMenu() {
      return this.selectedDocuments.length > 0
    },
    disableMultipleDownloadIcon() {
      //フォルダが含まれている場合は非活性にする
      const containFolders = this.selectedDocuments.filter(item => {
        return !Object.prototype.hasOwnProperty.call(item, "size");
      });
      if (containFolders.length > 0) return true;
      return false;
    },
    disableMultipleImportantIcon() {
      //ファイルが選択されていない場合は非活性にする
      const containFiles = this.selectedDocuments.filter(item => {
        return Object.prototype.hasOwnProperty.call(item, "size");
      });
      if (containFiles.length > 0) return false;
      return true;
    },
    downloadIconText() {
      return this.disableMultipleDownloadIcon ? this.disabledDownloadMsg : "ダウンロード"
    }
  },
  watch: {
    async searchDocumentsRange(_) {
      try {
        this.$vs.loading();
        await this.search(this, this.documentSearchQuery)
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    selectedStyle(val = DOCUMENT_DISPLAY_TYPE.GRID) {
      this.SET_SELECTED_CONTENT_VIEW_STYLE(val)
    },
    isSidebarActive(val) {
      this.SET_DOCUMENT_SIDEBAR_ACTIVE(val)
    },
    async searchQuery(val) {
      try {
        this.SET_DOCUMENT_SEARCH_QUERY(val)

        this.$vs.loading();
        await this.search(this, val)
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_DOCUMENT_SIDEBAR_ACTIVE",
      "SET_SELECTED_CONTENT_VIEW_STYLE",
      "SET_DOCUMENT_SEARCH_QUERY",
      "SET_SEARCHING",
      "SET_SEARCH_DOCUMENTS_RANGE",
      "RESET_SELECTED_DOCUMENTS"
    ]),
    ...mapActionsOfEnterpriseDocumentManager([
      "getCurrentPath",
      "getFileUrl",
      "moveFolder",
      "queryCurrentDocuments",
      "queryAllDocuments",
      "setImportantFile",
      "reloadDocuments",
      "downloadFile"
    ]),

    async setSearchDocumentRange() {

      if (this.selectedSidebarItem.startsWith('e:')) {
        return;
      }

      switch (this.selectedSidebarItem) {
        case DOCUMENT_SIDEBAR_KIND.IMPORTANT:
        case DOCUMENT_SIDEBAR_KIND.LATEST:
        case DOCUMENT_KIND.IMAGE:
        case DOCUMENT_KIND.VIDEO:
        case DOCUMENT_KIND.PDF:
        case DOCUMENT_KIND.WORD:
        case DOCUMENT_KIND.EXCEL:
        case DOCUMENT_KIND.POWERPOINT:
        case DOCUMENT_KIND.OTHER:
          this.SET_SEARCH_DOCUMENTS_RANGE("current");
          break;
        default:
          this.SET_SEARCH_DOCUMENTS_RANGE("all");
      }

    },

    search: _.debounce(async (self, query) => {
      self.RESET_SELECTED_DOCUMENTS();

      const searching = query.length > 0;
      self.SET_SEARCHING(searching);

      if (!searching) {
        await self.reloadDocuments();
        return;
      }

      if (self.searchDocumentsRange === "current") {
        await self.queryCurrentDocuments(query)
      } else {
        await self.queryAllDocuments(query)
      }

    }, 200),

    toggleDocumentSidebar(value) {
      if (!value && this.isDocumentSidebarClickNotClose) return;
      this.isSidebarActive = value
    },

    selectGridIcon() {
      this.SET_SELECTED_CONTENT_VIEW_STYLE(DOCUMENT_DISPLAY_TYPE.GRID)
    },

    selectListIcon() {
      this.SET_SELECTED_CONTENT_VIEW_STYLE(DOCUMENT_DISPLAY_TYPE.LIST)
    },

    async toggleMultiplePreview() {
      try {
        this.$vs.loading();

        const promiseAll = this.selectedDocuments
          .filter(item => {
            if (!item.type) return false;
            const kind = this.getDocumentMimeKind(item.type)
            return kind === DOCUMENT_KIND.IMAGE || kind === DOCUMENT_KIND.PDF
          })
          .map(item => this.getFileUrl(item.path))

        await Promise.all(promiseAll).then(items => {
          items.forEach(url => {
            window.open(url)
          });
        }).catch(error => {
          console.error(error);
        })
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },

    async toggleMultipleDownload() {
      this.$vs.loading();
      const promiseAll = this.selectedDocuments
        .filter(item => item.size)
        .map(item => {
          this.downloadFile(item).catch(_ => {
            const path = item.path.replace(this.documentRootPath, "")
            this.$vs.notify({
              title: `${ path }のダウンロードに失敗しました`,
              color: "danger",
              iconPack: "feather",
              icon: "icon-x-square",
              time: 3000
            });
          })
        });

      await Promise.all(promiseAll)
      this.$vs.loading.close();
      this.RESET_SELECTED_DOCUMENTS()
    },

    toggleMultipleTrash() {
      this.$refs.DocumentDeleteDialog.show()
    },

    toggleMultipleMoveFolder() {
      this.moveDocuments = _.cloneDeep(this.selectedDocuments);
      this.$refs.DocumentMoveDialog.show();
    },

    toggleMultipleCopyFolder() {
      this.moveDocuments = _.cloneDeep(this.selectedDocuments);
      this.$refs.DocumentCopyDialog.show();
    },

    async toggleMultipleImportant() {
      try {
        const _important = _.cloneDeep(!this.important);
        this.$vs.loading();
        const promiseAll = this.selectedDocuments
          .filter(item => item.size)
          .map(item => {
            const payload = {
              path: item.path,
              important: _important
            }
            return this.setImportantFile(payload)
          })
        await Promise.all(promiseAll).then(_ => {

          const msg = _important
            ? `重要書類へ追加しました`
            : `重要書類から解除しました`

          this.$vs.notify({
            title: msg,
            color: "success",
            iconPack: "feather",
            icon: "icon-check"
          });
          this.$vs.loading.close();
        }).catch(error => {
          console.error(error);
          throw error;
        })
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: `重要書類の設定に失敗しました`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
        this.$vs.loading.close();
      }
      this.RESET_SELECTED_DOCUMENTS()
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#search-area {
  .icon {
    color: $aisea-mouse-gray;
  }
}

#document-style-switch {
  input {
    display: none;
  }

  label {
    display: block;
    float: left;
    cursor: pointer;
    border: 1px solid $aisea-blue;
    background: $aisea-pure-white;
    color: $aisea-blue;
    text-align: center;
    line-height: 1;
    opacity: 1;
  }

  label.grid {
    border-radius: 4px 0px 0px 4px;
  }

  label.list {
    border-radius: 0px 4px 4px 0px;
  }

  input[type="radio"]:checked + label {
    background-color: $aisea-blue;
    color: $aisea-white;
  }
}

.right-item {
  .icon {
    color: $aisea-gray;
  }
  .icon:hover {
    border-radius: 5px;
    background: $aisea-white;
  }

  .icon-disabled {
    color: $aisea-mouse-gray;
  }
}
</style>